import { line as lineD3 } from "d3";

// ==== General functions

export const bandsCreate = function(
  data,
  svg,
  customName,
  mouseOverFct,
  mouseLeaveFct,
  mouseMoveFct = null,
  addId = false,
  idField = "id",
  mouseClickFct = null,
  svgAux = null
) {
  if (mouseMoveFct === null) {
    mouseMoveFct = mouseOverFct;
  }
  const svgContainer = svgAux ? svgAux : svg;
  // add vertical lines to show on hover
  var bands = svgContainer
    .selectAll(".bands" + customName)
    .data([data])
    .enter()
    .append("g")
    .attr("class", "bands" + customName);
  bands
    .selectAll("rect") // vertical line appears on hover
    .data(function(d) {
      return d;
    })
    .enter()
    .append("rect")
    .attr("x", function(d) {
      return svg.x(d.date) + Math.floor(svg.x.bandwidth() / 2);
    })
    .attr("y", 0)
    .attr("height", svg.height)
    .attr("width", 1)
    .attr("class", function(d, i) {
      return "bands" + customName + "" + (addId ? +d[idField] : i);
    })
    .style("stroke-width", Math.floor(svg.x.bandwidth()))
    .on("mouseover", mouseOverFct)
    .on("mouseleave", mouseLeaveFct)
    .on("mousemove", mouseMoveFct)
    .on("click", mouseClickFct);
};

export const bandsCreateCA = function(
  data,
  svg,
  customName,
  mouseMoveFct,
  addId = false,
  idField = "id"
) {
  // add vertical lines to show on hover
  var bands = svg
    .selectAll(".bands" + customName)
    .data([data])
    .enter()
    .append("g")
    .attr("class", "bands" + customName);
  bands
    .selectAll("rect") // vertical line appears on hover
    .data(function(d) {
      return d;
    })
    .enter()
    .append("rect")
    .attr("x", function(d) {
      return svg.x(d.date) + Math.floor(svg.x.bandwidth() / 2);
    })
    .attr("y", 0)
    .attr("height", svg.height)
    .attr("width", 1)
    .attr("class", function(d, i) {
      return "bands" + customName + "" + (addId ? d[idField] : i);
    })
    .style("stroke-width", Math.floor(svg.x.bandwidth()))
    .on("mousemove", mouseMoveFct);
};
export const hBandsCreate = function(
  data,
  svg,
  customName,
  yFieldName,
  mouseOverFct,
  mouseLeaveFct,
  mouseMoveFct = null
) {
  if (mouseMoveFct === null) {
    mouseMoveFct = mouseOverFct;
  }
  // add horizontal lines to show on hover
  var bands = svg
    .selectAll(".bands" + customName)
    .data([data])
    .enter()
    .append("g")
    .attr("class", "bands" + customName);
  bands
    .selectAll("rect") // horizontal line appears on hover
    .data(function(d) {
      return d;
    })
    .enter()
    .append("rect")
    .attr("x", 0)
    .attr("y", function(d) {
      return svg.y(d[yFieldName]) + Math.floor(svg.y.bandwidth() / 2);
    })
    .attr("height", 1)
    .attr("width", svg.width)
    .attr("class", function(d, i) {
      return "bands" + customName + "" + i;
    })
    .style("stroke-width", Math.floor(svg.y.bandwidth()))
    .on("mouseover", mouseOverFct)
    .on("mouseleave", mouseLeaveFct)
    .on("mousemove", mouseMoveFct);
};

export const dotCreate = function(
  svg,
  customName,
  circleSize,
  fillColor,
  strokeColor,
  strokeWidth = 1
) {
  svg.dot = svg.append("g");
  svg.dot
    .append("circle")
    .style("opacity", 0)
    .attr("fill", fillColor)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .attr("class", "dot" + customName)
    .attr("r", circleSize);
};

export const rectsCreate = function(
  svg,
  customName,
  width,
  height,
  fillColor,
  strokeColor,
  strokeWidth = 1
) {
  svg.dot = svg.append("g");
  svg.dot
    .append("rect")
    .attr("fill", fillColor)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .attr("class", "rect" + customName)
    .attr("width", width)
    .attr("height", height)
    .style("shape-rendering", "crispEdges");
};

export const hLineCreate = function(
  svg,
  customName,
  strokeColor,
  strokeWidth = 1
) {
  svg.hLine = svg.append("g");
  svg.hLine
    .append("line")
    .attr("class", "hHoverLine" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("x1", 0)
    .attr("x2", svg.width);
};

export const vLineCreate = function(
  svg,
  customName,
  strokeColor,
  strokeWidth = 1
) {
  svg.hLine = svg.append("g");
  svg.hLine
    .append("line")
    .attr("class", "vHoverLine" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("y1", 0)
    .attr("y2", svg.height);
};

export const candleCreate = function(
  svg,
  customName,
  strokeColor,
  strokeWidth = 1,
  svgAux = null
) {
  if (svgAux === null) {
    svgAux = svg;
  }
  svg.stck = svgAux.append("g");
  svg.stck
    .append("line")
    .attr("class", "cndlStck" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("x1", 0)
    .attr("x2", 0)
    .attr("y1", 0)
    .attr("y2", 0);
  svg.stck2 = svgAux.append("g");
  svg.stck2
    .append("line")
    .attr("class", "cndlStck2" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("x1", 0)
    .attr("x2", 0)
    .attr("y1", 0)
    .attr("y2", 0);
  svg.cndl = svgAux.append("g");
  svg.cndl
    .append("rect")
    .attr("class", "cndl" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", 0)
    .attr("height", 0);
};

export const barCreate = function(
  svg,
  customName,
  strokeColor,
  strokeWidth = 1,
  svgAux = null
) {
  if (svgAux === null) {
    svgAux = svg;
  }
  svg.bar = svgAux.append("g");
  svg.bar
    .append("rect")
    .attr("class", "bar" + customName)
    .style("opacity", 0)
    .attr("stroke", strokeColor)
    .attr("stroke-width", strokeWidth)
    .style("shape-rendering", "crispEdges")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", 0)
    .attr("height", 0);
};

export const dateInterpolate = function(xRange, xValue, x, width) {
  let hi, lo, rangeWidth;
  const count = xRange.length;
  if (count === 1) {
    return width / 2;
  }
  for (hi = 0; hi < count; hi++) {
    if (+xRange[hi] >= +xValue) {
      break;
    }
  }
  if (hi >= count - 1) {
    hi = count - 1;
    lo = hi - 1;
    rangeWidth = xRange[hi] - xRange[lo];
    return x(xRange[hi]) + (width * (xValue - xRange[hi])) / rangeWidth;
  } else if (hi === 0) {
    lo = 0;
    hi = 1;
  } else {
    lo = hi - 1;
  }
  rangeWidth = xRange[hi] - xRange[lo];
  return (
    (x(xRange[lo]) * (xRange[hi] - xValue) +
      x(xRange[hi]) * (xValue - xRange[lo])) /
    rangeWidth
  );
};

export const bigRectCreate = function(
  data,
  svg,
  customName,
  mouseOverFct,
  mouseLeaveFct,
  mouseMoveFct = null
) {
  if (mouseMoveFct === null) {
    mouseMoveFct = mouseOverFct;
  }
  // add rectangle to trigger hover event
  svg
    .append("rect")
    .attr("width", svg.width)
    .attr("height", svg.height)
    .style("fill", "rgba(0,0,0,0)")
    .on("mouseover", mouseOverFct)
    .on("mouseleave", mouseLeaveFct)
    .on("mousemove", mouseMoveFct);
};

export function recalculateLine({
  svg,
  fieldName,
  data,
  xt,
  customName,
  xIsDate = false
}) {
  let bandWidth;
  if (xIsDate === false) {
    bandWidth = svg.x.bandwidth();
  } else {
    bandWidth = 0;
  }
  const line = lineD3()
    .x(d => xt(d.date) + bandWidth / 2)
    .y(d => svg.y(d[fieldName]));

  svg[customName]
    .data([data])
    .join("path")
    .attr("d", line);
}
